import React from 'react'
import { Button } from 'react-bootstrap'

const LockContentComponent = ({ handleShow }) => {
  return (
    <>
      <div className="locked d-flex flex-column justify-content-center align-items-center text-center m-5 mx-md-auto">
        <h1>此功能目前僅開放給 PRO 版用戶使用！</h1>
        <h3>目前升級享專案特惠，數量有限，欲購從速</h3>
        <Button className="mt-3" size="lg" onClick={handleShow}>
          馬上升級PRO版會員
        </Button>
      </div>
    </>
  )
}

export default LockContentComponent
